export const ListShimmer = ({ rows = 4 }) => {
  return (
    <div className="space-y-4 animate-pulse">
      {Array.from({ length: rows }).map((_, idx) => (
        <div key={idx} className="h-16 bg-gray-200/70 rounded-lg w-full"></div>
      ))}
    </div>
  );
};
